<template>
<div class="manager_dashboard">
<user-menu />
<div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <CSRSidebarMenu v-if="csr == true" />
  <div class="content-wrapper">
    <div class="container-wrapper center">
    <div><h3 class="d-inline heading">Email or Login as Admin</h3></div>
    <div class="heading-seperator"></div>
    <div class="margin-bottom-10"></div>

               <b-card no-body>
                  <div class="row tasks_heading_row">
                     <div
                       class="bold col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3">
                       First Name
                     </div>
                     <div
                       class="bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">
                       Last Name
                     </div>
                     <div
                       class="bold col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6 override-padding">
                       Email
                     </div>
                   </div>

                   <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>

                     <b-card-text v-if="email_lists.length > 0">
                        <div v-for="(emaillist, index) in email_lists" class="tasklist-row">
                          <div class="row tasklist-item" style="margin: 0;">
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3">{{emaillist.admin_fname}}</div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{emaillist.admin_lname}}</div>
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 override-padding">{{emaillist.admin_email}}</div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1 override-padding">
                              <span v-if="emaillist.is_enabled == 1" v-on:click="switchUserLogin(emaillist.uid)" class="cursor-pointer">
                                <i class="fa fa-user spacer-icon"></i>Login
                              </span>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1 override-padding">
                             <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                             <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu-private' + index">
                               <li></li>
                               <li></li>
                               <li></li>
                             </ul>
                             <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                               <div class="action-dd-menu" @click="resetPasswordEmail(emaillist.admin_email)"><i class="cursor-pointer fa fa-key spacer-icon"></i>Reset Password</div>
                               <div class="action-dd-menu" @click="sendEmailForm(emaillist.admin_email), verrors.clear()"><i class="cursor-pointer fa fa-envelope-square spacer-icon"></i>Send Mail</div>
                             </div>
                             </div>
                         </div>
                          </div>
                          <div><hr></div>
                        </div>
                     </b-card-text>
                     <b-card-text v-else-if="loading == false">
                          No records found
                     </b-card-text>
               </b-card>
             </div>


  <ValidationModal :isModalVisible="isInfoModalVisible" v-if="successMessage" @close="isInfoModalVisible = false">
    <span class="pull-right text-danger">
      Loading...
    </span>
    <div slot="header" class="sub-heading">{{  successMessage }}</div>
    <div slot="body">

    </div>
    <div slot="footer" class="col-3 override-padding">
    </div>
  </ValidationModal>

  <SendEmailModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
    <div slot="header" class="sub-heading"><h3>Send Mail</h3></div>
    <div slot="body">
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
      {{ success_message }}
    </b-alert>
    <div style="clear: both"></div>
    <div class="col-12 override-padding">
      <input type="hidden" v-model="to_email">
      <input v-model="email_subject"
            name="email_subject"
            placeholder="Enter Subject"
            class="col-lg-12 input-height-25 padding-lr-5"
            v-validate="'required'"
            maxlength="255" />
      <div v-if="verrors.firstByRule('email_subject', 'required')" class="margin-bottom-5 validate-warning-msg">Subject is required</div>
    </div>
    <div style="clear: both;" class="margin-bottom-10"></div>
    <div class="col-12 override-padding">
    <textarea
        v-model="email_message"
        name="email_message"
        placeholder="Enter Message"
        class="email-message col-xs-12 col-md-12 col-lg-12 padding-lr-5 input-height-25"
        maxlength="500"
        v-validate="'required'">
        </textarea>
      <div v-if="verrors.firstByRule('email_message', 'required')" class="margin-bottom-5 validate-warning-msg">Message is required</div>
      <button
          v-on:click="sendEmailToAdmin()"
          class="btn btn-red col-lg-2 col-sm-2 col-3 input-height-25"
          ><b>Send</b></button>
    </div>
    </div>
    <div slot="footer" class="col-3 override-padding">
    </div>
  </SendEmailModal>


</div>
</div>
</div>
</div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import UserMenu from '../shared/user_menu.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import ValidationModal from '../shared/validation_modal_alert.vue';
import SendEmailModal from '../admin/create-tasklist-modal.vue';
import CSRSidebarMenu from '../shared/csr_sidebar_menu.vue';

export default {
        data() {
          return {
            email_lists: [],
            loading: false,
            showOverlay: false,
            successMessage: '',
            isInfoModalVisible: false,
            isModalVisible: false,
            email_subject: '',
            email_message: '',
            to_email: '',
            success_message: '',
            dismissCountDown: 0,
            userAccounts: {
                isUserLinkedMultipleLocations: false,
                locations: [],
                current: {},
            },
            locationsCount: 0,
            researcher: false,
            masterAdmin: false,
            csr: false,
          }
        },
        components: {
          UserMenu,
          MasteradminSidebarMenu,
          ValidationModal,
          SendEmailModal,
          CSRSidebarMenu,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            switchUserLogin: function(user_id) {
              axios.get('/admin_switch_user/' + user_id, {
              })
              .then(response => {
                let switch_admin_username = response.data.admin_username;
                let switch_admin_firstname = response.data.admin_firstname;
                let switch_admin_roles = response.data.admin_roles;
                let switch_admin_account_flag = response.data.admin_account_flag;
                this.$store.dispatch('switch_admin_user', { switch_admin_username, switch_admin_firstname, switch_admin_roles, switch_admin_account_flag });
                this.locations = response.data.locations_results;
                this.locationsCount = this.locations.length;
                this.userAccounts.isUserLinkedMultipleLocations = false;
                this.userAccounts.locations = this.locations;
                if (this.locationsCount > 1) {
                    this.userAccounts.isUserLinkedMultipleLocations = true;
                    this.$store.dispatch('set_user_locations', this.userAccounts);
                    this.navigate('/user/select-location');
                } else {
                    this.$store.dispatch('set_user_accountid', this.userAccounts.locations[0].accId);
                    this.$store.dispatch('set_user_locations', this.userAccounts);
                    if(response.data.admin_account_flag == 1) {
                      this.navigate("/school-admin-dashboard");
                    }
                    else {
                      this.navigate("/company-admin-dashboard");
                    }
                }
              })
              .catch(error => {

              });
            },
            navigate(path) {
        	   router.push(path);
    	      },
            isActive: function (tabvalue) {
                 return this.selectedComponent === tabvalue
            },
            getEmailorLoginListData: function(accountId) {
              axios.get('/account_email_loginlist/' + accountId, {
              })
              .then(response => {
                this.loading = false;
                this.email_lists = response.data;
              })
              .catch(error => {

              });
            },
            toggleDropdown (id) {
                document.getElementById(id).classList.toggle("show");
            },
            hideActionMenu(e) {
               var matches = document.getElementsByClassName('dropdown-content');
               for (var i=0; i<matches.length; i++) {
                 var container = document.getElementById('dropdown-container'+ i);
                 if (!container.contains(e.target)) {
                      if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                         document.getElementById('actionDropdown' + i).classList.remove('show');
                      }
                 }
               }
             },
            resetPasswordEmail(email) {
             axios('/custom/forgot_password/' + email,
               {
                 method: 'GET',
               }
             )
             .then(resp => {
               this.successMessage = "An email was sent to admin's mailbox to reset the password";
               this.isInfoModalVisible = true;
             })
             .catch(error => {

             })
           },
           sendEmailForm(email) {
             this.to_email = email;
             this.isModalVisible = true;
           },
           sendEmailToAdmin() {
             this.$validator.resume();
             this.$validator.validateAll().then((result) => {
               if (this.verrors.items.length === 0) {
                 axios('/account_lookup/send_emailto_admin',
                     {
                       method: 'POST',
                       data: {
                                emailAddress: this.to_email,
                                subject: this.email_subject,
                                message: this.email_message,
                             }
                     },
                   )
                   .then(response => {
                       this.success_message = 'Email sent.';
                       this.dismissCountDown = 5;
                       this.to_email = '';
                       this.email_subject = '';
                       this.email_message = '';
                       this.$validator.pause();
                    })
                   .catch(error => {

                   })
               }
             })
             .catch(() => {

             });
           },
           countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
           },
          },
          created() {
            var accountId = this.$route.params.account_id;
            this.getEmailorLoginListData(accountId);
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }
          },
          mounted() {
             document.addEventListener('click', this.hideActionMenu);
          },
          beforeDestroy() {
             document.removeEventListener('click', this.hideActionMenu);
          },
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 25px;
  color: #FFF;
  padding: 3px 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.input-height-30 {
  line-height: 30px;
}
.naics-code-wrapper {
  padding-left: 15px;
}
hr {
  border-top: 2px solid #8b8b8b;
  margin: 0px;
}
.tasklist-row:nth-of-type(odd) {
  background-color:#fff;
}
.tasklist-row:nth-of-type(even) {
  background-color:#e9e9e9;
}
.search-wrapper {
  background-color: transparent;
}
.heading-seperator {
  border-bottom: 2px solid #4c94cf;
}
.btn-blue {
  background-color: #4c94cf !important;
  border: 1px solid #4c94cf !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
}
.heading {
  font-size: 15px;
}
.tasklist-item {
  padding: 8px 0px 8px 0px;
}
.email-message {
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_email_or_login_list.vue